import { bodySegments, type UserSummary } from "@estelle/domain";

import { INACTIVE_USER_LABEL } from "@/modules/tasks/directories";

/**
 * A task comment with each mention shown as the person's name (#446, #448).
 *
 * Mentions are stored as `@[<userId>]` and drawn the way an order's thread
 * draws them: by looking the id up, never by reading a name out of the text, so
 * a rename shows and a hand-typed token cannot pass for someone else. An id the
 * directory does not list is someone who is not active, and is called that.
 * Everything else is shown exactly as written.
 */
export function MentionedText({
  body,
  users,
}: {
  body: string;
  users: readonly UserSummary[];
}) {
  return (
    <>
      {bodySegments(body).map((segment, index) =>
        segment.kind === "text" ? (
          <span key={index}>{segment.text}</span>
        ) : (
          <span
            key={index}
            className="bg-primary/10 text-primary-strong rounded px-1 font-medium"
          >
            @
            {users.find((user) => user.id === segment.userId)?.name ??
              INACTIVE_USER_LABEL}
          </span>
        ),
      )}
    </>
  );
}
